import React from 'react';
import classnames from 'classnames';
import { MoreOutlined } from '@ant-design/icons';
import { Dropdown, Button } from 'antd';
import styles from './index.less';

const MoreDropDown = ({ className = '', menu }) => {
  return (
    menu && (
      <Dropdown menu={menu} trigger={['click']}>
        <Button
          className={classnames(styles.moreDropDownButton, className)}
          icon={<MoreOutlined />}
          type="text"
        />
      </Dropdown>
    )
  );
};
export default MoreDropDown;
